import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('Sending...');

    // REPLACE WITH YOUR KEYS
    const SERVICE_ID = 'YOUR_SERVICE_ID';
    const TEMPLATE_ID = 'YOUR_TEMPLATE_ID';
    const PUBLIC_KEY = 'YOUR_PUBLIC_KEY';

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
      .then((result) => {
          setStatus('');
          alert("Message Sent Successfully!");
          form.current.reset();
      }, (error) => {
          setStatus('');
          console.log(error.text);
          alert("Failed to send message.");
      });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        
        {/* --- COLUMN 1: CONTACT INFO (Left) --- */}
        <div className="contact-column-info">
          <div className="owner-info">
            <h2 className="owner-name">NAMPALLY PRANAY</h2>
            <p className="owner-title">INTERIOR DESIGNER</p>
            <div className="title-divider-gold"></div>
          </div>

          <p className="contact-desc">
            Ready to transform your space? Contact us directly or use the form to schedule a consultation.
          </p>
          
          <div className="contact-details-list">
            <div className="detail-item">
              <span className="icon">📞</span>
              <span>(+91) 9160188232</span>
            </div>
            <div className="detail-item">
              <span className="icon">✉️</span>
              <span>sryinteriorsnlg@gmail.com</span>
            </div>
            <div className="detail-item">
              <span className="icon">🌐</span>
              <span>www.sryinteriors.com</span>
            </div>
            <div className="detail-item">
              <span className="icon">📍</span>
              <span>
                Kolan Shiva Reddy Colony, Main Road,<br/>
                Kuntloor Rd, Opp. Indian Oil Petrol Pump,<br/>
                Hayathnagar_Khalsa, Hyderabad, 501505
              </span>
            </div>
          </div>
        </div>

        {/* --- COLUMN 2: QR CODE (Middle) --- */}
        <div className="contact-column-qr">
          <div className="qr-wrapper">
            <img src="/qrcode.png" alt="Location QR" className="qr-image" />
            <p className="qr-text">SCAN HERE FOR LOCATION</p>
          </div>
        </div>

        {/* --- COLUMN 3: FORM (Right) --- */}
        <div className="contact-column-form">
          <form ref={form} onSubmit={sendEmail} className="contact-form">
            <h3 className="form-header">SEND US A MESSAGE</h3>
            
            <div className="form-group">
              <label>Name</label>
              <input type="text" name="user_name" required placeholder="John Doe" />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input type="email" name="user_email" required placeholder="john@example.com" />
            </div>

            <div className="form-group">
              <label>Phone</label>
              <input type="tel" name="user_phone" placeholder="+1 (555) 000-0000" />
            </div>

            <div className="form-group">
              <label>Project Type</label>
              <select name="project_type">
                <option value="Residential">Residential Design</option>
                <option value="Commercial">Commercial Space</option>
                <option value="Renovation">Full Renovation</option>
                <option value="Consultation">General Consultation</option>
              </select>
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea name="message" rows="3" required placeholder="Tell us about your project..."></textarea>
            </div>

            <button type="submit" className="submit-btn">
              {status === 'Sending...' ? 'SENDING...' : 'SEND REQUEST'}
            </button>
          </form>
        </div>

      </div>
    </section>
  );
};

export default Contact;